import { colorVar, fontFamilyVar, fontWeightVar, radiusVar, spacingVar } from '@root/styles/Global';
import { createGlobalStyle } from 'redoc';

export const GlobalReqEditorStyles = createGlobalStyle`
    .try-it-button {
        background-color: ${colorVar('success')};
        color: ${colorVar('white')};
        border: none;
        padding: ${spacingVar('sm')} ${spacingVar('md')};
        border-radius: ${radiusVar('md')};
        cursor: pointer;
        font-size: 14px;
        font-weight: ${fontWeightVar('medium')};
        font-family: ${fontFamilyVar('base')};
        box-shadow: 0 2px 8px rgba(${colorVar('success')}, 0.25);
        white-space: nowrap;
        transition: all 0.2s ease;
        margin: ${spacingVar('xl')};

        &:hover {
            background-color: ${colorVar('success-hover')};
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(${colorVar('success')}, 0.35);
        }

        &-container {
            display: flex;
            align-items: center;
            gap: ${spacingVar('lg')};
            margin-bottom: 20px;
        }
    }
`;
